import React, { ReactNode } from 'react';
import TextArea from '../../../../components/envago/TextArea/TextArea';
import { MeloAttributeEntry } from '../../../../redux/jobs/jobs.types';

export const MELO_ATTRIBUTE_NOTE_MAX_LENGTH = 500;

export interface MeloAttributeFormProps<V> {
    value: V;
    onChange: (value: V) => void;
    t: (key: string) => string;
}

export interface MeloAttributeTypeConfig<V = any> {
    type: MeloAttributeEntry['type'];
    labelKey: string;
    emptyValue: V;
    toValue: (entry: MeloAttributeEntry) => V;
    toEntry: (value: V) => MeloAttributeEntry;
    isValid: (value: V) => boolean;
    renderValue: (entry: MeloAttributeEntry) => ReactNode;
    renderForm: (props: MeloAttributeFormProps<V>) => ReactNode;
}

const NOTE_CONFIG: MeloAttributeTypeConfig<string> = {
    type: 'NOTE',
    labelKey: 'jobs.details.meloAttribute.keys.NOTE',
    emptyValue: '',
    toValue: (entry) => (entry.type === 'NOTE' ? entry.note : ''),
    toEntry: (value) => ({ type: 'NOTE', note: value.trim() }),
    isValid: (value) => value.trim().length > 0,
    renderValue: (entry) => (entry.type === 'NOTE' ? entry.note : null),
    renderForm: ({ value, onChange, t }) => (
        <TextArea
            value={value}
            onChange={onChange}
            maxLength={MELO_ATTRIBUTE_NOTE_MAX_LENGTH}
            placeholder={t('jobs.details.meloAttribute.valueLabel')}
            className={'resize-none'}
            hasFocus
        />
    ),
};

export const MELO_ATTRIBUTE_TYPES: MeloAttributeTypeConfig[] = [NOTE_CONFIG];

export const getMeloAttributeType = (type: MeloAttributeEntry['type']): MeloAttributeTypeConfig =>
    MELO_ATTRIBUTE_TYPES.find((c) => c.type === type) ?? MELO_ATTRIBUTE_TYPES[0];

export const resolveAvailableMeloAttributeTypes = (configured: string[]): MeloAttributeEntry['type'][] =>
    configured.filter((typeKey): typeKey is MeloAttributeEntry['type'] => MELO_ATTRIBUTE_TYPES.some((c) => c.type === typeKey));
